module.exports = __webpack_public_path__ + "media/images/landing/header_two-8664f9296063f32ee3ca03dbab9b6eb7.jpg";